import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";
import formControl from "globals/form-control";

const getUpdateColumns = (onEdit) => {
  return [
    {
      Header: "ACD Number",
      accessor: "extension",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      isUserGenerated: true,
      width: 6,
      disabled: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
      validation: formControl.string().required("Required"),
    },
    {
      Header: "Did Number",
      accessor: "didNumber",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      isUserGenerated: true,
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Queue Name",
      accessor: "data",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: "select",
      isUserGenerated: true,
      width: 6,
      options: {
        keyField: "systemName",
        keyDescription: "description",
        values: [],
        url: "queue/listAll/queue",
      },
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Strategy",
      accessor: "strategy",
      displayInList: true,
      allowInForm: true,
      isUserGenerated: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
      controlType: "select",
      width: 6,
      options: {
        keyField: "id",
        keyDescription: "description",
        values: [
          { id: "round-robin", description: "Round Robin" },
          {
            id: "ring-all",
            description: "Ring All",
          },
          { id: "top-down", description: "Top Down" },
          { id: "acd", description: "ACD" },
          { id: "console", description: "Console" },
        ],
      },
    },
    {
      Header: "Failover",
      accessor: "failOver",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      isUserGenerated: true,
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "timezone",
      accessor: "timezone",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      isUserGenerated: true,
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "FromTime",
      accessor: "fromTime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "date",
      controlType: "time",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
      isUserGenerated: true,
    },
    {
      Header: "To Time",
      accessor: "toTime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "date",
      controlType: "time",
      isUserGenerated: true,
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Non Working Data",
      accessor: "nonworkingData",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      isUserGenerated: true,
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Non Working App",
      accessor: "nonworkingApp",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      isUserGenerated: true,
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Day Inbound Cos",
      accessor: "dayInboundCos",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
      controlType: "select",
      options: {
        keyField: "cos",
        keyDescription: "cos",
        values: [],
        url: "inboundCos/list/cos",
      },
    },
    {
      Header: "Night Inbound Cos",
      accessor: "nightInboundCos",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: "select",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
      options: {
        keyField: "cos",
        keyDescription: "cos",
        values: [],
        url: "inboundCos/list/cos",
      },
    },
    {
      Header: "Day Outbound Cos",
      accessor: "dayOutboundCos",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 6,
      controlType: "select",
      Cell: ({ value }) => <DefaultCell value={value} />,
      options: {
        keyField: "cos",
        keyDescription: "cos",
        values: [],
        url: "outboundCos/list/cos",
      },
    },
    {
      Header: "Night Outbound Cos",
      accessor: "nightOutboundCos",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: "select",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
      options: {
        keyField: "cos",
        keyDescription: "cos",
        values: [],
        url: "outboundCos/list/cos",
      },
    },
    {
      Header: "OverrideMoh",
      accessor: "overrideMoh",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      isUserGenerated: true,
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Chime File Name",
      accessor: "chimePath",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      isUserGenerated: true,
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Chime Interval",
      accessor: "chimeInterval",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      isUserGenerated: true,
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Time Out (In Sec)",
      accessor: "ringTime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      isUserGenerated: true,
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Extension ACD",
      accessor: "isExtensionBasedAcd",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      isUserGenerated: true,
      controlType: "boolean",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Auto Answer",
      accessor: "autoLift",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      controlType: "boolean",
      isUserGenerated: true,
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Sunday",
      accessor: "isSun",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      controlType: "boolean",
      isUserGenerated: true,
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Monday",
      accessor: "isMon",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      controlType: "boolean",
      isUserGenerated: true,
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Tuesday",
      accessor: "isTue",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      controlType: "boolean",
      isUserGenerated: true,
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "WednesDay",
      accessor: "isWed",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      controlType: "boolean",
      isUserGenerated: true,
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Thursday",
      accessor: "isThu",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      controlType: "boolean",
      isUserGenerated: true,
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Friday",
      accessor: "isFri",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      controlType: "boolean",
      isUserGenerated: true,
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Saturday",
      accessor: "isSat",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      controlType: "boolean",
      isUserGenerated: true,
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },

    {
      Header: "action",
      accessor: "id",
      displayInList: true,
      allowInForm: false,
      Cell: ({ row, value }) => (
        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
          <RowAction
            row={row}
            value={value}
            onDelete={onDelete}
            onEdit={onEdit}
          />
          <QueueAssociation row={row} />
        </div>
      ),
    },
  ];
};

export { getUpdateColumns };
